import get from 'transmute/get';
export const getVisitorIdentificationEnabled = data => get('visitorIdentificationEnabled', data);